import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_ACTIVO, ESTATUS_AUTORIZADO, ESTATUS_CANCELADO } from 'utils/constants';

import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/nominas/descuentos-carga-externa-archivo';
export const baseURI2 = '/nominas/descuentos-carga-externa-archivo';
/**
 * GET
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getExternaDescuentos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getExternaDescuento = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};
/**
 * GET  Errores
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const getExternaDescuentoErrores = async (params) => {
  try {
    const response = await API.get('nominas/descuentos-carga-externa-error', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postExternaDescuento = async (values) => {
  try {
    const hasArchivo = values?.archivo?.file instanceof File;
    const payload = hasArchivo
      ? getFormattedValues(values, { files: ['archivo'], formData: true })
      : getFormattedValues(values);
    const config = hasArchivo ? { headers: { 'Content-Type': 'multipart/form-data' } } : undefined;
    const response = await API.post(baseURI2, payload, config);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchExternaDescuento = async (id, values) => {
  try {
    const hasArchivo = values?.archivo?.file instanceof File;
    const payload = hasArchivo
      ? getFormattedValues(values, { files: ['archivo'], formData: true })
      : values;
    const config = hasArchivo ? { headers: { 'Content-Type': 'multipart/form-data' } } : undefined;
    const response = await API.patch(`${baseURI2}/${id}`, payload, config);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 *
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const getExternaDescuentosTotales = async (id, values) => {
  try {
    const response = await API.get(`/nominas/descuentos-carga-externa-archivo-totales-vista-optimized/${id}/`, values);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 *
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteExternaDescuento = async (id) => {
  try {
    const response = await API.delete(`${baseURI2}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const autorizarExternaDescuento = async (id) => {
  try {
    const response = await API.patch(`${baseURI2}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const CancelarExternaDescuento = async (id) => {
  try {
    const response = await API.patch(`${baseURI2}/${id}`, { estados_globales: ESTATUS_CANCELADO });
    onSuccess(response, 'Cancelado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const reactivarExternaDescuento = async (id) => {
  try {
    const response = await API.patch(`${baseURI2}/${id}`, { estados_globales: ESTATUS_ACTIVO });
    onSuccess(response, 'Reactivado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT - Agrega registros a un descuento externo ya creado
 * @param {number} id - ID del descuento externo
 * @param {object[]} registros - Arreglo de registros
 * @returns {Promise<{}>}
 */
export const putExternaDescuento = async (id, registros) => {
  try {
    const response = await API.put(`/nominas/agregar-descuentos-carga-externa-archivo/${id}/`, { registros });
    return response.data; // { task_id, id, message }
  } catch (err) {
    onError(err);
    return false;
  }
};

export const autorizarExternaDescuentoAEmpleados = async (id) => {
  try {
    const response = await API.put(`/nominas/agregar-descuentos-carga-externa-archivo-a-empleados/${id}/`, {});
    return response.data; // { task_id, id, message }
  } catch (err) {
    onError(err);
    return false;
  }
};
